@if (condition) {
  <div class="c-alert" [ngClass]="classType">
    <p><i [class]="icon"></i> <span [innerHTML]="translatedMessage()"></span></p>
  </div>
}
